function ChooseChantierTypeStep({ tree, loading, selectedTypeId, expandedIds, onToggleParent, onSelectChild }) {
  if (loading) {
    return (
      <div className="TypeTree-loading">
        <span className="Spinner" />
      </div>
    );
  }

  return (
    <div className="TypeTree">
      {tree.map((parent) => {
        const isExpanded = expandedIds.includes(parent.id);
        const hasSelected = parent.children.some((c) => c.id === selectedTypeId);
        const selectedChild = parent.children.find((c) => c.id === selectedTypeId);
        const accent = parent.color || '#f6a500';

        return (
          <div className="TypeTree-group" key={parent.id}>
            <button
              type="button"
              className={`TypeTree-parentRow${hasSelected ? ' is-selected' : ''}`}
              style={hasSelected ? { color: accent, backgroundColor: `${accent}18` } : undefined}
              onClick={() => onToggleParent(parent.id)}
            >
              <span className="TypeTree-dot" style={{ backgroundColor: accent }} />
              <span className="TypeTree-parentLabel">{parent.name}</span>
              {hasSelected && selectedChild && (
                <span className="TypeTree-badge" style={{ backgroundColor: accent }}>
                  {selectedChild.name}
                </span>
              )}
              <span className="TypeTree-chevron">{isExpanded ? '▲' : '▼'}</span>
            </button>

            {isExpanded && (
              <div className="TypeTree-children">
                {parent.children.length === 0 ? (
                  <span className="TypeTree-empty">Aucun sous-type</span>
                ) : (
                  parent.children.map((child) => {
                    const isSelected = selectedTypeId === child.id;
                    const childAccent = child.color || accent;
                    return (
                      <button
                        type="button"
                        key={child.id}
                        className={`TypeTree-childRow${isSelected ? ' is-selected' : ''}`}
                        style={
                          isSelected
                            ? { color: childAccent, borderColor: childAccent, backgroundColor: `${childAccent}18` }
                            : undefined
                        }
                        onClick={() => onSelectChild(child.id)}
                      >
                        <span>{child.name}</span>
                        {isSelected && <span className="TypeTree-check">✓</span>}
                      </button>
                    );
                  })
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default ChooseChantierTypeStep;
